// #region Mapeadores & helpers (Caixa)
// Mantém snake_case para DTOs
export function caixaFromBackend(dto) {
  return { ...dto };
}

export function movimentoFromBackend(dto) {
  return { ...dto };
}

export function isCaixaAberto(caixa) {
  return caixa && caixa.status === 'ABERTO';
}

export function computeCaixaStats(caixas = []) {
  const total = caixas.length;
  let abertos = 0;
  let fechadosManual = 0;
  let fechadosAuto = 0;
  let totalEntradas = 0;
  let totalSaidas = 0;

  caixas.forEach(c => {
    if (c.status === 'ABERTO') abertos++;
    else if (c.status === 'FECHADO_MANUAL') fechadosManual++;
    else if (c.status === 'FECHADO_AUTO') fechadosAuto++;
    totalEntradas += c.total_entradas || 0;
    totalSaidas += c.total_saidas || 0;
  });

  const saldoAtual = (totalEntradas - totalSaidas).toFixed(2);
  return {
    total,
    abertos,
    fechadosManual,
    fechadosAuto,
    totalEntradas,
    totalSaidas,
    saldoAtual: Number(saldoAtual),
  };
}
// #endregion
